import { SectionHeading } from '@/components/ui/SectionHeading';
import { FaqItem } from '@/components/ui/FaqItem';

type Props = {
  eyebrow?: string;
  title: string;
  description?: string;
  items: { question: string; answer: string }[];
};

export function FaqSection({ eyebrow = 'FAQ', title, description, items }: Props) {
  return (
    <section className="px-6 md:px-12 lg:px-20 py-24 md:py-32">
      <div className="mx-auto max-w-[1200px] grid lg:grid-cols-[0.8fr_1.2fr] gap-12 lg:gap-20">
        <SectionHeading eyebrow={eyebrow} title={title} description={description} />
        <div className="flex flex-col">
          {items.map((item) => (
            <FaqItem key={item.question} question={item.question} answer={item.answer} />
          ))}
        </div>
      </div>
    </section>
  );
}
